/* eslint-disable no-console */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
const debug = require('debug');
const path = require('path');

class Log {
  constructor(prefix) {
    this.prefix = prefix;

    if (typeof process.env.DEBUG === "undefined") {
      let logger;

      try {
        const packagePath = path.resolve(process.cwd(), 'config/default');
        ({ logger } = require(packagePath));
      } catch (error) {
        console.warn('falling back to path.basename(process.cwd()) logger', path.basename(process.cwd()));
        logger = path.basename(process.cwd());
      }

      this.BASE = logger || path.basename(process.cwd());
      debug.enable(`${this.BASE}:*`);
    } else {
      this.BASE = process.env.DEBUG.split(':')[0];
    }
  }

  generateMessage(level, message) {
    // Set the prefix which will cause debug to enable the message
    const namespace = `${this.BASE}:${level}:${this.prefix}`;
    const createDebug = debug(namespace);
    const sanitizedMessage = this.sanitizedMessage(message);

    createDebug(sanitizedMessage);
  }

  sanitizedMessage(msg) { // eslint-disable-line
    return typeof msg === 'string' ? msg.replace(/\/\/.*@/g, '//***:***@') : msg;
  }

  debug(message) {
    return this.generateMessage('debug', message);
  }

  info(message) {
    return this.generateMessage('info', message);
  }

  warn(message) {
    return this.generateMessage('warn', message);
  }

  error(message) {
    return this.generateMessage('error', message);
  }
}

module.exports = Log;
